import React, { type ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  /** Right-aligned actions (CTAs, meters). */
  actions?: ReactNode;
  /** Heading level + scale. `h1` (default) is the page title (26px); `h2` is a
   *  section heading that sits beneath a page title (18px) — e.g. a settings
   *  sub-section — keeping both a single-`h1` outline and a real size step. */
  as?: "h1" | "h2";
};

/** The one page header every screen shares (AITS-489). Ported from the
 *  prototype's `.page-hd` — 26px/700 title, tight tracking, optional subtitle,
 *  actions right-aligned. Supersedes the retired ui/section-title.tsx. */
export function VbPageHeader({ title, subtitle, actions, as: Heading = "h1" }: Props) {
  return (
    <header className="vb-page-hd">
      <div className="vb-page-hd__left">
        <Heading>{title}</Heading>
        {subtitle && <p className="vb-page-hd__sub">{subtitle}</p>}
      </div>
      {actions && <div className="vb-page-hd__actions">{actions}</div>}
    </header>
  );
}

export default VbPageHeader;
